import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { environment } from '@merchant-portal/environments/environment';

export const ENVIRONMENT_TOKEN = new InjectionToken<typeof environment>('environment');

export const REPORT_ERROR_TOKEN = new HttpContextToken(() => '');
